import AdminClient from '@/api/AdminClient';
import moment from 'moment';

export default class UniqueStudentsReport {
  constructor() {
    this.adminClient = null;
    this.schoolId = null;

    this.loading = false;
    this.error = null;

    this.parameters = {
      from: null,
      through: null,
      includeStatuses: undefined,
      paidBy: undefined,
      customCampusTags: [],
    };
    this.count = 0;
  }

  initialize($http, schoolId) {
    this.adminClient = new AdminClient($http);
    this.schoolId = schoolId;

    return this;
  }

  withCustomTags(tags) {
    this.parameters.customCampusTags = tags;

    return this;
  }

  asApprovedStatus() {
    this.parameters.includeStatuses = [
      'Upcoming'
    ];
    return this;
  }
  
  asSuccessStatus() {
    this.parameters.includeStatuses = [
      'Upcoming',
      'Successful'
    ];
    return this;
  }
  
  asCanceledStatus() {
    this.parameters.includeStatuses = [
      'UserCanceled',
      'UserLateCanceled',
    ];
    return this;
  }

  asAbsentStatus() {
    this.parameters.includeStatuses = [
      'UserNoShow',
      'BothNoShow',
    ];
    return this;
  }

  asAllStatuses(){
    this.parameters.includeStatuses = undefined;
    
    return this;
  }

  asPaidByCampus() {
    this.parameters.paidBy = 'Campus';

    return this;
  }

  asPaidOutOfPocket(){
    this.parameters.paidBy = 'Student';

    return this;
  }

  from(d) {
    this.parameters.from = d ? moment(d) : null;
    
    return this;
  }

  through(d) {
    this.parameters.through = d ? moment(d) : null;
    
    return this;
  }

  async getAllPast() {
    this.parameters.from = null;
    this.parameters.through = moment();

    await this.fetch();
  }

  async getLast30Days() {
    this.parameters.from = moment().add(-30, 'day');
    this.parameters.through = moment();

    await this.fetch();
  }

  async getUpcoming() {
    this.parameters.from = moment();
    this.parameters.through = null;

    await this.fetch();
  }

  async fetch() {
    try {
      this.loading = true;

      const response = await this.adminClient.getCollegeAdminSessionsUniqueStudents(
        this.schoolId,
        this.parameters.from,
        this.parameters.through,
        this.parameters.includeStatuses,
        this.parameters.paidBy,
        this.parameters.customCampusTags
      );

      this.count = response.count;

      this.loading = false;
    } catch (error) {
      this.error = error;
    }
  }
}
